import { type IconDefinition } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cva, type VariantProps } from "class-variance-authority";

const styles = cva("", {
  variants: {
    variant: {
      success: "text-kiosk-text-primary",
      error: "text-kiosk-text-error",
      info: "text-kiosk-accent-primary"
    }
  },
  defaultVariants: {
    variant: "success"
  }
});

type ModalIconProps = VariantProps<typeof styles> & {
  icon: IconDefinition;
};

export const ModalIcon = ({ icon, variant }: ModalIconProps) => (
  <FontAwesomeIcon icon={icon} fontSize={240} className={styles({ variant })} />
);
